import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_ITEMS } from "../content";
import BuyButton from "./BuyButton";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-[#EAE6F0] bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <a href="#start" data-testid="nav-logo" className="flex items-center gap-2">
          <img
            src="/assets/edunation-logo.png"
            alt="eduNation — strona główna kursu"
            className="h-9 w-auto"
          />
        </a>
        <nav aria-label="Nawigacja główna" className="hidden lg:block">
          <ul className="flex items-center gap-6 text-sm font-semibold text-[#34343F]">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  data-testid={`nav-link-${item.href.slice(1)}`}
                  className="transition-colors duration-200 hover:text-[#FF008B]"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex items-center gap-2">
          <BuyButton testid="nav-cta-buy" location="header" className="!min-h-[40px] !px-5 !py-2 !text-sm" />
          <button
            type="button"
            data-testid="nav-menu-toggle"
            aria-expanded={open}
            aria-controls="mobile-menu"
            aria-label={open ? "Zamknij menu" : "Otwórz menu"}
            onClick={() => setOpen((v) => !v)}
            className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-[#242344] lg:hidden"
          >
            {open ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
          </button>
        </div>
      </div>
      <div
        id="mobile-menu"
        className="acc-panel border-t border-[#EAE6F0] bg-white lg:hidden"
        data-open={open}
      >
        <div>
          <ul className="space-y-1 px-4 py-3">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  data-testid={`nav-mobile-link-${item.href.slice(1)}`}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-base font-semibold text-[#34343F] hover:bg-[#FDF4F8] hover:text-[#FF008B]"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
}
